import axios from 'axios';
export const apiUrl : string =(process.env.REACT_APP_API_URL as string);

export const api = axios.create({
    baseURL: apiUrl,
})

export default api;
